export default __webpack_public_path__ + "static/media/po-financing-usecase1.885cb25b.png";